<script>
    import Gallery from "./Gallery.svelte";
    import {mediaUrlStore} from "../core/app-store.js";

    export let section;
    export let tenantKey = '';

    let textCutExpanded = false;

    function toggleCutHandler() {
        textCutExpanded = !textCutExpanded;
    }
</script>

<style>
.text-block {
    position: relative;
    z-index: 1;
    color: var(--main-font-color);
    background-color: var(--header-background);
    margin-bottom: -.8rem;
    width: 100%;
    overflow: hidden;
}
@media (min-width: 768px) {
    .text-block {
        margin: 1rem 0;
    }
    .text-block,
    .slider,
    .image { border-radius: 1rem;}
}
.text-content {
    position: relative;
    z-index: 10;
    padding: 2rem 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
.title {
    font-size: var(--fs-150);
    font-weight: 600;
    padding: 0;
    margin: 0;
    font-family: var(--font-1);
    line-height: 20px;
    width: 100%;
}
.text {
    font-size: var(--fs-100);
    font-weight: 400;
    line-height: 135%;
    margin: 0;
    white-space: break-spaces;
}
.text-cut {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.text-cut--4 {-webkit-line-clamp: 4;}
.text-cut--8 {-webkit-line-clamp: 8;}
.text-cut--12 {-webkit-line-clamp: 12;}
.read-more-btn {
    border: none;
    font-size: var(--fs-120);
    font-family: inherit;
    background: transparent;
    cursor: pointer;
    line-height: 1;
    color: inherit;
    margin-bottom: -1rem;
}
.slider {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
}
.image {
    opacity: .35;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.buttons {
    gap: .75rem;
    columns: 300px;
    display: flex;
}
@media (max-width: 767px) {
    .buttons {
        flex-direction: column;
        align-items: unset;
        text-align: center;
    }
}
@media (min-width: 768px) {
    .buttons {
        flex-direction: row;
    }
    .buttons--left {
        justify-content: start;
    }
    .buttons--center {
        justify-content: center;
    }
    .buttons--right {
        justify-content: end;
    }
}
.text-block-btn {
    border: 1px solid var(--price-item-bg-color);;
    color: var(--price-item-bg-color);
    border-bottom-right-radius: 0.75rem;
    border-top-left-radius: 0.75rem;
    text-decoration: none;
    text-align: center;
    font-family: inherit;
    font-size: inherit;
    font-weight: 500;
    padding: .4rem .8rem;
    cursor: pointer;
}
.text-block-btn:hover {
    opacity: .75;
    box-shadow: 3px 3px 2px 1px rgba(0,0,0,0.25);
}

.video-container {
    position: absolute;
    overflow: hidden;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
}
.video-container video {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

</style>

<section class="text-block flex"
         id={'s' + section.id}
         style:color="{section.textBlock?.textColor ? section.textBlock.textColor : 'var(--main-font-color)'}"
         style:background="{section.textBlock?.background?.color ? section.textBlock.background.color : null}"
         style:text-align="{section.textBlock?.alignment || 'left'}"
         style:min-height="{section.textBlock?.height ? section.textBlock.height + 'vh' : 'unset'}"
         >

    <div class="text-content flex flex-fill">

        {#if ((section.title || '').length > 0)}
            <h3 class="title">{ section.title }</h3>
        {/if}

        {#if (section.textBlock.gallery)}
            <div>
                <Gallery gallery={section.textBlock.gallery} tenantKey={tenantKey}></Gallery>
            </div>
        {/if}

        {#if ((section.textBlock?.text || '').length > 0)}
            <p class="text flex-fill { section.textBlock.cutText && !textCutExpanded ? 'text-cut' : ''} { section.textBlock.cutText ? 'text-cut--'+section.textBlock.cutText : ''}">
                { section.textBlock.text || '' }
            </p>
        {/if}

        {#if (section.textBlock.cutText)}
            <button class="read-more-btn" on:click={() => toggleCutHandler()}>
            {#if (!textCutExpanded)}
                <svg width="1em" height="1em" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 0.5L6 5.5L11 0.5" stroke="currentColor"/>
                </svg>
            {:else}
                <svg width="1em" height="1em" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 6L6 1L1 6" stroke="currentColor"/>
                </svg>
            {/if}
        </button>
        {/if}

        {#if (section.textBlock.buttons && section.textBlock.buttons.length > 0)}
            <div class="buttons buttons--{section.textBlock.alignment || 'left' }">
                {#each section.textBlock.buttons as button }
                    {#if (button.text && button.link)}
                    <a class="text-block-btn"
                       style:color="{button.color}"
                       style:border-color="{button.color}"
                       href="{button.link}"
                       target={ button.target || '_blank' }
                       rel="noopener nofollow">
                        { button.text }
                    </a>
                    {/if}
                {/each}
            </div>
        {/if}
    </div>

    {#if section.textBlock.background?.videoUrls}
        <div class="video-container">
            <video src="{section.textBlock.background?.videoUrls[0]}" autoplay muted loop loading="lazy">
            </video>
        </div>
    {/if}

    {#if section.textBlock.background?.images}
        <div class="slider">
            {#each section.textBlock.background.images as image}
                {#if (image && image.length > 0)}
                <img class="image" width="100%" src="{$mediaUrlStore}{tenantKey}{image}"
                     alt="{section.title}"
                     loading="lazy"
                     style="opacity: {section.textBlock.background.opacity ? section.textBlock.background.opacity : .35}">
                {/if}
            {/each}
        </div>
    {/if}
</section>
